import React from 'react'
import ReactDOM from 'react-dom/client'
import { JobList } from './Components/JobsList/JobsList'
import { JobsSearch } from './Components/JobsSearch/JobsSearch'

const backend = document.querySelectorAll('.neos-backend')

if (!backend.length) {
    const jobNavigator = document.querySelector('.js-jobs-search')
    ReactDOM.createRoot(jobNavigator).render(<JobsSearch />)

    const jobList = document.querySelector('.js-jobs-listing')
    ReactDOM.createRoot(jobList).render(<JobList />)
}
